import RedeemHandler from './RedeemHandler';

export default RedeemHandler;
